import React, {useEffect, useState, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, Typography,Radio, FormLabel, FormControl, Grid, Checkbox, FormControlLabel, SelectField, Option, Link, TextField, RadioGroup, FormHelperText, Button, Box, Table, TableHead, TableBody, TableRow, TableCell } from "@deere/fuel-react";
import {
    findAnswerIndex,
    getTranslation,
    getLDTranslation,
    findSelectionIndex,
    getNewCheckValueAnswer,
    containsCheckBoxAnswer,
    formatStrDate,
    getSelectionsDependson,
    getChildrenToRemove
} from '../utils/utils';
import {CLASSNAME_FILEINPUT, EMPTY_BODY, QUESTION_TYPES, LINKS, LINK_LABEL_LABEL, LINK_LABEL_LINK, FILE_FORMAT_PDF} from '../utils/surveyLiterals'
import store from '../redux/store'
import "../assets/css/Sections.css";
import { updateGenAnswer } from '../redux/action/genericSurveyAction';
import { getValidator } from '../utils/validationRequiredFactory'
import { getFileS3 } from '../services/survey.service';
import { useOktaAuth } from '@okta/okta-react';
import { useTranslation } from "react-i18next";
import {PDFViewer} from "../components/PDFViewer";
import {DatePicker, InputAdornment} from "@deere/fuel-react";
import CalendarMonth from '@mui/icons-material/CalendarMonth'
import moment from "moment";
import { showInputTextErorr } from '../utils/validation';
import { getBoundary } from '../services/external.service';
import { ReactComponent as FileUploadIcon } from "@deere/ux.brand-foundations/icons/upload.svg";
import { OverlayTrigger, Popover } from '@deere/ux.uxframe-react';
import { buildMatrixPreview } from '../utils/matrixQuestionUtils';



const shouldRender = (question,answers,review,questions) => {
    let shouldRender = true;
    if(review && (!answers || answers.length === 0)){// Case where user has not started working on survey yet - show all 
        return shouldRender;
    }
    let queToCheck = question;
    while(queToCheck.idQuestionDepends !== null && queToCheck.idSelectionDependson !== null && shouldRender){
        shouldRender = false;
        let parentQuestion = questions.find(ques=>parseInt(ques.id) === parseInt(queToCheck.idQuestionDepends));
        if(answers && answers.length > 0){
            let parentAnswer = answers.find(ans=>parseInt(ans.questionId) === parseInt(queToCheck.idQuestionDepends));
            const deps = getSelectionsDependson(queToCheck);
            if(queToCheck.regexp === "notdepends"){
                if(parentAnswer && parentAnswer.answer && !deps.some((dep) => parentAnswer.answer.toString().split(',').map((value) => value.trim()).includes(dep))){
                    shouldRender = true;
                }
            }
            else{
                if(parentQuestion.type === QUESTION_TYPES.CHECK && parentAnswer && deps.some((dep) => parentAnswer.answer.split(',').includes(dep))){
                    shouldRender = true;
                }
                else if ((parentQuestion.type === QUESTION_TYPES.SEL_CNTRY || parentQuestion.type === QUESTION_TYPES.SEL_CTY_UW) && parentAnswer && parentAnswer.answer && parentAnswer.answer !== "") {
                    shouldRender = true;
                }
                else if(parentAnswer && deps.includes(parentAnswer.answer.toString())){
                    shouldRender = true;
                }
            }
            queToCheck = parentQuestion;
        }
        queToCheck = parentQuestion;
    }
    return shouldRender;
}

export default function Section({survey, section, review, questionsToValidate, setAnswers, answers, validated, setValidated, countryList, countryListUnknown, uploadedFiles, setUploadedFiles }) {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const surveyResponse = useSelector(state => state.genericSurvey.surveyResponses[survey.code]);
    const surveyForm = useSelector(state => state.genericSurvey.surveyAnswersForm[survey.code]);
    const campaignAssigned = useSelector(state => state.campaign.campaignAssigned);
    const questions = section.questions.filter(qu => qu.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const requiredValidator = getValidator(survey.code);
    const matrixMemberCodes = new Set(
        questions.filter((q) => q.type === QUESTION_TYPES.MATRIX).flatMap((m) => [...buildMatrixPreview(m, questions).memberCodes])
    );
    const [campaignId, setCampaignId] = useState(null); 
    const [stateList, setStateList] = useState([]);
    const [fileFormatError, setFileFormatError] = useState(false);
    const { authState } = useOktaAuth();
    const checkBoxRef = useRef(null);
    const fileInputref = useRef([]);
    const validator = useSelector(state => state.validator.fields);
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

    useEffect(() => {
         if(surveyResponse && surveyResponse.surveyAnswers){
            if(!review){
                if(surveyForm.length > 0)
                    setAnswers([...surveyForm])
                else
                    setAnswers([...surveyResponse.surveyAnswers])
            }
         }         
         if(campaignAssigned){
            setCampaignId(campaignAssigned.id);
         }                                                                                          
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [surveyResponse,campaignAssigned]);

     useEffect(() => {
      if (uploadedFiles && uploadedFiles.length === 0 && answers && answers.length > 0) {
        const tempArr = [];
        answers.forEach((ans) => {
          ans.answer.split(", ").forEach((a) => {
            tempArr.push({fileName: a});
          });
        });
        setUploadedFiles(tempArr);
      }
     }, [uploadedFiles, answers])


    if (!section)
        return EMPTY_BODY; 

    const isError = (data) => {
        let reqValidator = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        let required = reqValidator !== undefined && reqValidator !== null ? reqValidator : data.required
        if (typeof validated === "boolean" && validated && required) {
            return showInputTextErorr(answers, data.id);
        }
        return false;
    }

    const updateAnswer = (e, questionId, question) => {
        setValidated(false);
        const childRemoved = getChildrenToRemove(question && question.children, (ch) => e.target && e.target.value === String(ch.selectionDependson));
        dispatch(updateGenAnswer({ questionId: questionId, answer: e.target ? e.target.value : e, surveyCode: survey.code, childRemoved }));
        setAnswers([...store.getState().genericSurvey.surveyAnswersForm[survey.code]]);
        if (question && (question.type === QUESTION_TYPES.SEL_CNTRY || question.type === QUESTION_TYPES.SEL_CTY_UW)) {
            updateStatesOptions(e, questionId, question.type === QUESTION_TYPES.SEL_CTY_UW ? true : false);
        }
    }

    const updateStatesOptions = (e, questionId, includeUnknown) => {
      const countryListInfo = includeUnknown ? countryListUnknown : countryList;
        if (e && e.target && e.target.value) {
          const countryCode = Array.isArray(countryListInfo) ? countryListInfo.find((c) => c.name === e.target.value) : null;
          if (countryCode && countryCode.iso2CountryCode) {
            getBoundary(token, countryCode.iso2CountryCode)
              .then((res) => {
                if (Array.isArray(res)) {
                  res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
                  setStateList((prevState) => {
                    const index = prevState.findIndex((ps) => ps.questionId === questionId);
                    index > -1 ? (prevState[index].states = [...res]) : prevState.push({ questionId: questionId, states: [...res] });
                    return [...prevState];
                  });
                }
              })
              .catch((err) => {
                console.log(err);
                setStateList((prevState) => {
                  const index = prevState.findIndex((ps) => ps.questionId === questionId);
                  index > -1 ? (prevState[index].states = []) : prevState.push({ questionId: questionId, states: [] });
                  return [...prevState];
                });
              });
          }
        }
      };
    
    const updateAnswerFile = (e, questionId) => {
        setFileFormatError(false);
        setValidated(false);
        const requestNumber = campaignAssigned? campaignAssigned.assignments[0].id : '';        
        const fileName = e.target.files[0].name;
        const fileType = fileName.split(".")[fileName.split(".").length - 1];
        if (fileName.split(".").length === 1) {
          setFileFormatError(true);
          e.target.value = null;
        } else {
          let indx = findAnswerIndex(questionId, answers);
          const answer = indx >= 0 ? answers[indx].answer : "";
          const fileNumber = `file${uploadedFiles.length + 1}`;
          const fileName = `rn${requestNumber}${fileNumber}.${fileType}`
          dispatch(updateGenAnswer({ questionId: questionId,answer: answer === "" ? fileName : `${answer}, ${fileName}`, surveyCode: survey.code }));
          setAnswers([...store.getState().genericSurvey.surveyAnswersForm[survey.code]]);
          setUploadedFiles((prevState) => {
            const newState = [...prevState];
            newState.push({fileName: fileName, fileNumber: fileNumber, fileData: e.target.files[0]});
            return  newState;
          });
        }
    }

    const updateCheckAnswer = (e, question,exclusive) => {
        setValidated(false);
        const tmpValue = (exclusive && e.target.checked)? e.target.value + ',': null;
        const exclusiveSelection = question.selections.find(s => s.exclusive);
        let newCheckValue = exclusive ? tmpValue : getNewCheckValueAnswer(question.id, answers, e);     
        const childRemoved = getChildrenToRemove(question.children, (ch) => Boolean(newCheckValue) && newCheckValue.includes(String(ch.selectionDependson)));
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {//Remove Question
            dispatch(updateGenAnswer({ questionId: question.id, answer: '',surveyCode: survey.code, childRemoved}));
        } else {//Update Question
            if(exclusiveSelection && newCheckValue.includes(exclusiveSelection.value)){newCheckValue = e.target.value + ','};
            dispatch(updateGenAnswer({ questionId: question.id, answer: newCheckValue,surveyCode: survey.code, childRemoved}));
        }
        setAnswers([...store.getState().genericSurvey.surveyAnswersForm[survey.code]])
    }

    const fileUploadClickHandler = (data) => {
      fileInputref.current.value = "";
      fileInputref.current[`que_${data.id}`].click();
    };

    function createRadioSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : "";
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, data.selections) : -1;
        let selection = selectionIdx >= 0 ? data.selections[selectionIdx] : null;
        let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
    
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            {data.html ? (
              <Typography size="sm" component="p" gutterBottom fontWeight="semibold" dangerouslySetInnerHTML={{ __html: getTranslation(data, "text") }} />
            ) : (
              <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
                {getTranslation(data, "text")}
              </Typography>
            )}
            <Typography size="sm" component="p" gutterBottom>
              {selection !== null ? getTranslation(selection, "text") : ""}
            </Typography>
          </Grid>
        ) : (
          <FormControl
            required={required !== undefined && required !== null ? required : data.required}
            sx={{ "& .MuiFormLabel-root": { fontSize: "14px" }, "& .MuiFormLabel-asterisk": { color: "#c21020" } }}
            key={`q${data.questionId}`}
            id={data.code}
          >
            {data.html ? (
              <FormLabel>
                <Typography component="label" size="sm" fontWeight="semibold" dangerouslySetInnerHTML={{ __html: getTranslation(data, "text") }} />
              </FormLabel>
            ) : (
              <FormLabel>{getTranslation(data, "text")}</FormLabel>
            )}
            <RadioGroup>
              {data.selections
                .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                .map(
                  (i) =>
                    i.active && (
                      <FormControlLabel
                        checked={indx >= 0 && answers[indx] && answers[indx].answer === i.value}
                        value={i.value}
                        id={i.id}
                        key={i.id}
                        control={<Radio name={`${getTranslation(section, "description")}-${data.id}`} sx={isError(data) && {color: "#c21020"}}/>}
                        label={getTranslation(i, "text")}
                        name={`${getTranslation(section, "description")}-${data.id}`}
                        sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
                        onChange={(e) => updateAnswer(e, data.id, data)}
                        data-testid={i.id}
                      />
                    )
                )}
            </RadioGroup>
            {isError(data) ? <FormHelperText sx={{color: '#c21020'}}> {t("bs_required")}</FormHelperText> : null}
          </FormControl>
        ) : null;
      }

      function createCheckSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : "";
        let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        let arrSelections = [];
        data.selections.forEach((sel) => {
            const arrAns = answer.split(",");
            const index = arrAns.findIndex((ans) => ans === sel.value);
            if (index > -1) arrSelections.push(sel);
        });
        return shouldRender(data, answers, review, questions) ? review ? (
            <Grid key={`q${data.questionId}`}>
                <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
                {getTranslation(data, "text")}
                </Typography>
                {arrSelections.map((sel) => {
                if (sel.html) return <Typography size="sm" component="p" gutterBottom dangerouslySetInnerHTML={{ __html: sel ? getTranslation(sel, "text") : "" }} />;
                else
                    return (
                    <Typography size="sm" component="p" gutterBottom>
                        {sel ? getTranslation(sel, "text") : ""}
                    </Typography>
                    );
                })}
            </Grid>
            ) : (
          <FormControl sx={{ "& .MuiFormLabel-root": { fontSize: "14px" }, "& .MuiFormLabel-asterisk": { color: "#c21020" }  }} key={`q${data.questionId}`} id={data.code} required={required !== undefined && required !== null? required:data.required}>
            {data.text && data.text !== "" && <FormLabel>{getTranslation(data, "text")}</FormLabel>}
            {data.selections
              .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
              .map((i) => (
                <FormControlLabel
                  control={<Checkbox name={`${getTranslation(section, 'description')}-${data.id}`}  sx={isError(data) && {color: "#c21020"}} />}
                  value={i.value}
                  key={i.id}
                  id={i.id}
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
                  name={`${getTranslation(section, 'description')}-${data.id}`}
                  onChange={(e) => updateCheckAnswer(e, data, i.exclusive)}
                  data-testid={i.id}
                  checked={containsCheckBoxAnswer(i.value, answer)}
                  ref={checkBoxRef}
                  attrquestioncode ={data.code}
                  disabled={!containsCheckBoxAnswer(i.value, answer) && data.code === "coc_que16"}
                  label={
                    data.text === "" ? (
                      i.html ? (
                        <FormLabel>
                            <Typography onClick={() => fnAutoSelectOption(data, i.exclusive)} component="label" size="sm" fontWeight='semibold' dangerouslySetInnerHTML={{ __html: getTranslation(i, "text") }} />
                        </FormLabel>
                      ) : (
                        <FormLabel>
                            {getTranslation(i, "text")}
                        </FormLabel>
                      )
                    ) : i.html ? (
                      <Typography onClick={() => fnAutoSelectOption(data, i.exclusive)} component="label" size="xs" dangerouslySetInnerHTML={{ __html: getTranslation(i, "text") }} />
                    ) : (
                      getTranslation(i, "text")
                    )
                  }
                />
              ))}
              {isError(data) ? <FormHelperText sx={{color: '#c21020'}}> {t("bs_required")}</FormHelperText> : null}
          </FormControl>
        ) : null;
    }

    const downloadFileHandler = async (e, fileName) => {
      e.preventDefault();
      const index = uploadedFiles ? uploadedFiles.findIndex((file) => file.fileName === fileName) : -1;
      if (index > -1 && uploadedFiles[index].fileData) {
        //download from local
        const link = document.createElement("a");
        link.download = fileName;
        link.href = URL.createObjectURL(uploadedFiles[index].fileData);
        link.click();
        URL.revokeObjectURL(link.href);
      } else {
        //download from s3
        if (!campaignId) return;
        const url = await getFileS3(campaignId, fileName, authState.accessToken.accessToken);
        if (url.length > 0) {
          window.open(url[0]);
        }
      }
    };
    
    function createFileSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        let saved = indx >= 0 ? answers[indx].surveyResponseId : 0;
        const answer = indx >= 0 ? answers[indx].answer : "";
        const required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
              {answer && answer !== "" && answer.split(", ").length > 0 && saved > 0 ? (
                <OverlayTrigger
                  placement="bottom"
                  trigger="click"
                  overlay={
                    <Popover id="popover-example">
                      <Popover.Content>
                        {answer.split(", ").map((item) => (
                          <>
                            <Link href="#" key={item} onClick={(e) => downloadFileHandler(e, item)}>{item}</Link>
                            <br/>
                          </>
                        ))}
                      </Popover.Content>
                    </Popover>
                  }
                >
                <Link href="#" onClick={e => e.preventDefault()}>{"View Added Files"}</Link>
              </OverlayTrigger>
              ) : (
                "No files attached"
              )}
            </Typography>
          </Grid>
        ) : (
          <>
            <FormLabel>{getTranslation(data, "text")}</FormLabel>
            <Grid container>
              <Grid item xs={2}>
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={(ref) => (fileInputref.current[`que_${data.id}`] = ref)}
                  onChange={(e) => updateAnswerFile(e, data.id)}
                  name={getTranslation(section, "description") + "-" + data.id}
                />
                <Button variant="secondary" startIcon={<FileUploadIcon />} size="small" onClick={() => fileUploadClickHandler(data)}>
                  Upload Files
                </Button>
              </Grid>
              <Grid item xs={10}>
                <Typography size="xs" fontWeight={"semibold"} component="label">
                  {answer && answer !== "" && answer.split(", ").length > 0 ? (
                    <OverlayTrigger
                      placement="bottom"
                      trigger="click"
                      overlay={
                        <Popover id="popover-example">
                          <Popover.Content>
                            {answer.split(", ").map((item) => (
                              <>
                                <Link href="#" key={item} onClick={(e) => downloadFileHandler(e, item)}>{item}</Link>
                                <br/>
                              </>
                            ))}
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <Link href="#" onClick={e => e.preventDefault()}>{"View Added Files"}</Link>
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>
            </Grid>
            {isError(data) ? <FormHelperText sx={{ color: "#c21020" }}> {t("bs_required")}</FormHelperText> : null}
          </>
      ) : null;
    }
  
    function createTextArea(data) {
        let indx = findAnswerIndex(data.id, answers);
        let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
              {indx >= 0 ? answers[indx].answer : ""}
            </Typography>
          </Grid>
        ) : (
            <FormControl id={data.code} fullWidth>
                <TextField
                    required={required !== undefined && required !== null ? required : data.required}
                    onChange={(e) => updateAnswer(e, data.id)}
                    value={indx >= 0 ? answers[indx].answer : ""}
                    name={`${getTranslation(section, "description")}-${data.id}`}
                    variant="outlined"
                    sx={{ "& .MuiFormLabel-root": { fontSize: "14px" } }}
                    label={getTranslation(data, "text")}
                    minRows={3}
                    multiline={true}
                    error={isError(data)}
                    helperText={isError(data) ? t("bs_required") : ""}
                />
            </FormControl>
        ) : null;
    }

    function createInput(data) {
        let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        let indx = findAnswerIndex(data.id, answers);
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
              {indx >= 0 ? answers[indx].answer : ""}
            </Typography>
          </Grid>
        ) : (
            <FormControl id={data.code} fullWidth>
                <TextField
                    required={required !== undefined && required !== null ? required : data.required}
                    onChange={(e) => updateAnswer(e, data.id)}
                    value={indx >= 0 ? answers[indx].answer : null}
                    name={`${getTranslation(section, "description")}-${data.id}`}
                    variant="outlined"
                    sx={{ "& .MuiFormLabel-root": { fontSize: "14px" } }}
                    error={isError(data)}
                    helperText={isError(data) ? t("bs_required") : ""}
                    label={getTranslation(data, "text")}
                />
            </FormControl>
        ) : null
    }
    
    const fnAutoSelectOption = (data, exclusive) => {
        if(checkBoxRef.current.attributes.attrquestioncode.nodeValue === "coc_que16"){
            checkBoxRef.current.disabled = false;
            const e = { target: { checked: true, value: "1" } };
            updateCheckAnswer(e, data, exclusive) 
        }
    }

    const datePickerOnChange = (e,question) => {
        setValidated(false);
        const event = {target:{value: ''}}
        let dateValue = new Date()
        if(Array.isArray(e) && e.length > 0){
            dateValue = moment(e[0]).isValid() ? e[0] : new Date()
            event.target.value = dateValue
        }
        else{
            event.target.value = dateValue
        }

        updateAnswer(event,question.id)
    }



    const createDatePicker = (question) => {
        const requiredField = review ? false : requiredValidator(question,section,answers,questionsToValidate);
        const indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : ''

        return shouldRender(question,answers,review, questions) ? review ? 
            <Grid key={`q${question.questionId}`}>
                <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
                    {getTranslation(question, "text")}
                </Typography>
                <Typography size="sm" component="p" gutterBottom>
                    {indx >= 0 ?  formatStrDate(answers[indx].answer) : ''}
                </Typography>
            </Grid>
        :
            <FormControl sx={{ "& .MuiFormLabel-root": { fontSize: "14px" }, "& .MuiFormLabel-asterisk": { color: "#c21020" } }} fullWidth required={requiredField !== undefined && requiredField !== null ? requiredField : question.required} id={question.code}>
                <FormLabel>{getTranslation(question, "text")}</FormLabel>
                <DatePicker
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><CalendarMonth /></InputAdornment>,
                        required: requiredField !== undefined && requiredField !== null? requiredField:question.required,
                        name:`${getTranslation(section, 'description')}-${question.id}`,
                        error: isError(question),
                        helperText : isError(question) ? t('bs_required') : null,
                    }}
                    onChange={(e) => {datePickerOnChange(e, question)}}
                    minDate={new Date()}
                    name={`${getTranslation(section, 'description')}-${question.id}`}
                    value={answer}
                />
            </FormControl>
        : null;
    }

    const createSelect = (data) => {
        const required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        const answer = findAnswerIndex(data.id, answers) >= 0 ? answers[findAnswerIndex(data.id, answers)].answer : "";
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, data.selections) : -1;
        let selection = selectionIdx >= 0 ? data.selections[selectionIdx] : null;
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold" >
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
                {selection !== null ? getTranslation(selection, "text") : ""}
            </Typography>
          </Grid>
        ) : (
            <formControl fullWidth id={data.code}>
                <SelectField
                    label={getTranslation(data, "text")}
                    required={required !== undefined && required !== null ? required : data.required}
                    sx={{ "& .MuiFormLabel-root": { fontSize: "14px" } }}
                    onChange={(e) => updateAnswer(e, data.id)}
                    value={answer}
                    helperText={isError(data) ? t("bs_required") : ""}
                    error={isError(data)}
                >
                    <Option value="">
                    {t("lbl_dropdown_select")}
                    </Option>
                    {data.selections &&
                    data.selections
                        .sort((a, b) => (parseInt(a.value) > parseInt(b.value) ? 1 : -1))
                        .map((opt) => (
                        <Option key={opt.id} value={opt.value}>
                            {getTranslation(opt, "text")}
                        </Option>
                        ))}
                </SelectField>
            </formControl>
        ) : null;
    };

    const createCountrySelect = (data, includeUnknown) => {
      const countryListInfo = includeUnknown ? countryListUnknown : countryList;
        const required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        const answer = findAnswerIndex(data.id, answers) >= 0 ? answers[findAnswerIndex(data.id, answers)].answer : "";
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, data.selections) : -1;
        let selection = selectionIdx >= 0 ? data.selections[selectionIdx] : null;
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold" >
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
                {selection !== null ? getTranslation(selection, "text") : ""}
            </Typography>
          </Grid>
        ) : (
            <formControl fullWidth id={data.code}>
                <SelectField
                    label={getTranslation(data, "text")}
                    required={required !== undefined && required !== null ? required : data.required}
                    sx={{ "& .MuiFormLabel-root": { fontSize: "14px" } }}
                    onChange={(e) => updateAnswer(e, data.id, data)}
                    value={answer}
                    helperText={isError(data) ? t("bs_required") : ""}
                    error={isError(data)}
                >
                    <Option value="">
                    {t("lbl_dropdown_select")}
                    </Option>
                    {countryListInfo && countryListInfo.length > 0 &&
                        countryListInfo.map((opt) => (
                        <Option key={opt.iso2CountryCode} value={opt.name}>
                            {opt.name}
                        </Option>
                        ))}
                </SelectField>
            </formControl>
        ) : null;
    };

    const createStateSelect = (data) => {
        const required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
        const answer = findAnswerIndex(data.id, answers) >= 0 ? answers[findAnswerIndex(data.id, answers)].answer : "";
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, data.selections) : -1;
        let selection = selectionIdx >= 0 ? data.selections[selectionIdx] : null;
        const index = stateList ? stateList.findIndex((sl) => sl.questionId === data.idQuestionDepends) : -1;
        const options = index > -1 ? stateList[index].states : [];
        return shouldRender(data, answers, review, questions) ? review ? (
          <Grid key={`q${data.questionId}`}>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold" >
              {getTranslation(data, "text")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom>
                {selection !== null ? getTranslation(selection, "text") : ""}
            </Typography>
          </Grid>
        ) : (
            <formControl fullWidth id={data.code}>
                <SelectField
                    label={getTranslation(data, "text")}
                    required={required !== undefined && required !== null ? required : data.required}
                    sx={{ "& .MuiFormLabel-root": { fontSize: "14px" } }}
                    onChange={(e) => updateAnswer(e, data.id)}
                    value={answer}
                    helperText={isError(data) ? t("bs_required") : ""}
                    error={isError(data)}
                >
                    <Option value="">
                    {t("lbl_dropdown_select")}
                    </Option>
                    {options && options.length > 0 &&
                        options.map((opt) => (
                        <Option key={opt.name} value={opt.name}>
                            {opt.name}
                        </Option>
                        ))}
                </SelectField>
            </formControl>
        ) : null;
    };
    const getAnswer = (questionId) => {
        const indx = findAnswerIndex(questionId, answers);
        return indx >= 0 && answers[indx].answer ? answers[indx].answer : "";
    };

    const getMatrixAnswerText = (que) => {
        const answer = getAnswer(que.id);
        if (!answer) return "";
        switch (que.type) {
            case QUESTION_TYPES.SELECT:
            case QUESTION_TYPES.RADIO: {
                const selection = que.selections?.find((s) => s.value === answer);
                return selection ? getTranslation(selection, "text") : "";
            }
            case QUESTION_TYPES.CHECK:
                return (que.selections || [])
                    .filter((s) => containsCheckBoxAnswer(s.value, answer))
                    .map((s) => getTranslation(s, "text"))
                    .join(", ");
            case QUESTION_TYPES.DATEPICKER:
                return formatStrDate(answer);
            default:
                return answer;
        }
    };

    const createMatrixCell = (que) => {
        const answer = getAnswer(que.id);
        const error = isError(que);
        const sortedSelections = [...(que.selections || [])].filter((s) => s.active !== false).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1));
        const smallLabel = { "& .MuiFormControlLabel-label": { fontSize: "12px!important" } };
        switch (que.type) {
            case QUESTION_TYPES.SELECT:
                return (
                    <SelectField value={answer} onChange={(e) => updateAnswer(e, que.id, que)} error={error} name={`${getTranslation(section, "description")}-${que.id}`}>
                        <Option value="">{t("lbl_dropdown_select")}</Option>
                        {sortedSelections.map((opt) => <Option key={opt.id} value={opt.value}>{getTranslation(opt, "text")}</Option>)}
                    </SelectField>
                );
            case QUESTION_TYPES.SEL_CNTRY:
            case QUESTION_TYPES.SEL_CTY_UW: {
                const countryListInfo = que.type === QUESTION_TYPES.SEL_CTY_UW ? countryListUnknown : countryList;
                return (
                    <SelectField value={answer} onChange={(e) => updateAnswer(e, que.id)} error={error} name={`${getTranslation(section, "description")}-${que.id}`}>
                        <Option value="">{t("lbl_dropdown_select")}</Option>
                        {(countryListInfo || []).map((opt) => <Option key={opt.iso2CountryCode} value={opt.name}>{opt.name}</Option>)}
                    </SelectField>
                );
            }
            case QUESTION_TYPES.RADIO:
                return (
                    <RadioGroup row sx={{ justifyContent: "center" }}>
                        {sortedSelections.map((sel) => (
                            <FormControlLabel
                                key={sel.id}
                                value={sel.value}
                                checked={answer === sel.value}
                                control={<Radio name={`${getTranslation(section, "description")}-${que.id}`} sx={error && { color: "#c21020" }} />}
                                label={getTranslation(sel, "text")}
                                sx={smallLabel}
                                onChange={(e) => updateAnswer(e, que.id, que)}
                            />
                        ))}
                    </RadioGroup>
                );
            case QUESTION_TYPES.CHECK:
                return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                        {sortedSelections.map((sel) => (
                            <FormControlLabel
                                key={sel.id}
                                value={sel.value}
                                checked={containsCheckBoxAnswer(sel.value, answer)}
                                control={<Checkbox name={`${getTranslation(section, "description")}-${que.id}`} sx={error && { color: "#c21020" }} />}
                                label={getTranslation(sel, "text")}
                                sx={smallLabel}
                                onChange={(e) => updateCheckAnswer(e, { ...que, children: que.children || [] }, sel.exclusive)}
                            />
                        ))}
                    </Box>
                );
            case QUESTION_TYPES.DATEPICKER:
                return (
                    <DatePicker
                        InputProps={{ startAdornment: <InputAdornment position="start"><CalendarMonth /></InputAdornment>, error }}
                        onChange={(e) => datePickerOnChange(e, que)}
                        minDate={new Date()}
                        value={answer}
                    />
                );
            case QUESTION_TYPES.OPEN:
                return <TextField value={answer} onChange={(e) => updateAnswer(e, que.id)} error={error} multiline minRows={2} name={`${getTranslation(section, "description")}-${que.id}`} />;
            default:
                return <TextField value={answer} onChange={(e) => updateAnswer(e, que.id)} error={error} name={`${getTranslation(section, "description")}-${que.id}`} />;
        }
    };

    const createMatrix = (data) => {
        if (!shouldRender(data, answers, review, questions)) return null;
        const { rows, columns } = buildMatrixPreview(data, questions);
        const helpText = data.translations?.[0]?.helpText || data.helpText;
        const labelText = { fontSize: "14px", display: "block" };
        const cellBorder = { borderRight: "1px solid #e0e0e0" };
        const hasError = !review && columns.some(({ cells }) => cells.some((cell) => isError(cell)));
        return (
            <Box id={data.code} sx={{ width: "100%" }}>
                <FormLabel sx={labelText}>{getTranslation(data, "text")}</FormLabel>
                {helpText && <FormLabel sx={{ ...labelText, fontSize: "12px", fontStyle: "italic", mt: 1, whiteSpace: "pre-line" }}>{helpText}</FormLabel>}
                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: "6px", overflowX: "auto", mt: 1 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                <TableCell sx={cellBorder} />
                                {columns.map(({ question }) => (
                                    <TableCell key={question.id} align="center" sx={cellBorder}>
                                        <FormLabel sx={{ ...labelText, fontSize: "12px" }} required={!review && question.required}>{getTranslation(question, "text")}</FormLabel>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, rowIndex) => (
                                <TableRow key={row.id} sx={{ backgroundColor: rowIndex % 2 ? "#fafafa" : "inherit" }}>
                                    <TableCell sx={{ ...cellBorder, width: "30%" }}>
                                        <FormLabel sx={{ ...labelText, fontSize: "12px" }}>{getTranslation(row, "text")}</FormLabel>
                                    </TableCell>
                                    {columns.map(({ question, cells }) => (
                                        <TableCell key={cells[rowIndex].id} align="center" sx={cellBorder}>
                                            {review ? (
                                                <Typography size="sm" component="p">{getMatrixAnswerText(cells[rowIndex])}</Typography>
                                            ) : (
                                                createMatrixCell(cells[rowIndex])
                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                {hasError ? <FormHelperText sx={{ color: "#c21020" }}> {t("bs_required")}</FormHelperText> : null}
            </Box>
        );
    };

    const createQuestionLink =(data) => {
      let indx = findAnswerIndex(data.id, answers);
      return (
        <>
        {data.links.map((l) => 
        <Grid>
            <Typography className="mt-3"size="sm" component="p" gutterBottom fontWeight="semibold">
              <Link href={l.url} target="_blank">
                {getTranslation(l, "text")}
              </Link>
            </Typography>
          </Grid>
        )}
        </>
        )
    }


    return (<>
        <Card>
            <CardContent id={section ? section.description : ''}>
                <Grid className="mb-4">
                  <Typography className='pb-1 font-weight-bold'variant="h2">
                      {getTranslation(section,'description')}               
                  </Typography>                                
                  <Typography className="mb-1" size='lg' variant="subtitle1">
                      {getLDTranslation(section,'longDescription')}
                  </Typography>
                  {section.links? (section?.links.map((link)=>
                      <Typography  size="sm" component="p" variant="h3">
                          <Link href={link.url} target="_blank">
                            {getTranslation(link, "text")} 
                          </Link>
                      </Typography> 
                  )
                  ) :null
                }
              </Grid>
               
                <>
                    {
                        <>
                            {            
                                questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).filter((q) => !matrixMemberCodes.has(q.code)).map((q) =>
                                    <Grid className="d-block mb-4" key={q.id}>
                                        {q.type === QUESTION_TYPES.MATRIX ? createMatrix(q) : <></>}
                                        {q.type === QUESTION_TYPES.RADIO && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                        {q.type === QUESTION_TYPES.CHECK && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                                        {q.type === QUESTION_TYPES.OPEN && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                                        {q.type === QUESTION_TYPES.OPEN_SMALL && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
                                        {q.type === QUESTION_TYPES.FILE && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createFileSection(q) : <></>}
                                        {q.type === QUESTION_TYPES.VIEWER && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? <PDFViewer q={q} survey={survey} accessToken={authState?.accessToken?.accessToken}/> : <></>}
                                        {q.type === QUESTION_TYPES.DATEPICKER && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDatePicker(q) : <></>}
                                        {q.type === QUESTION_TYPES.SELECT && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createSelect(q) : <></>}
                                        {q.type === QUESTION_TYPES.SEL_CNTRY && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCountrySelect(q, false) : <></>}
                                        {q.type === QUESTION_TYPES.SEL_CTY_UW && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCountrySelect(q, true) : <></>}
                                        {q.type === QUESTION_TYPES.SEL_STATE && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createStateSelect(q) : <></>}
                                        {q.links && q.links.length>0 ?createQuestionLink(q): <></>}
                                    </Grid>
                                )
                            }
                        </>
                    }
                </>
            </CardContent>
        </Card>        
    </>)
}
